import { DatoCmsPdv } from 'lib/datoCms/queries/getAllPdvLabels';
import { DatoCmsSignUp } from 'lib/datoCms/queries/getAllSignUpLabels';

export const getLabelsPromoBonus = (labels: DatoCmsSignUp | DatoCmsPdv) => {
  return {
    titlePromoBonus: labels.titleThirdForm,
    descriptionPromoBonus: labels.descriptionThirdForm,
    titlePromoBonusAffiliate: labels.titleThirdFormAffiliate,
    descriptionPromoBonusAffiliate: labels.descriptionThirdFormAffiliate,
    descriptionPromoCode: labels.descriptionPromoCode,
    promoCode: labels.promoCode,
    placeholderPromoCode: labels.placeholderPromoCode,
    errorMessagePromoCode: labels.errorMessagePromoCode,
    bonusList: labels.bonusList,
  };
};
